/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:29:59
 * @LastEditTime: 2021-01-08 14:20:52
 * @LastEditors: cc
 */
'use strict';

/* created by cc 2016 03=07
    功能介绍： 列表sce过滤器
    使用方式：渲染在列表上渲染后台返回的style或者font等样式，避免手动遍历
    所需参数：param:截取的字符个数
*/
angular.module('trsSceModule', []).filter('trsSce', ['$sce',
    function($sce) {
        return function(input) {
            if (angular.isDefined(input)) {
                input = $sce.trustAsHtml(window.filterXSS(input));
            }
            return input;
        };
    }]).filter('trsSceHtmlContent', ['$sce',
    function($sce) {
        return function(input) {
            if (angular.isDefined(input)) {
                input = $sce.trustAsHtml(input);
            }
            return input;
        };
    }]).filter('trsSceUrl', ['$sce',
    function($sce) {
        return function(input) {
            if (angular.isDefined(input)) {
                input = $sce.trustAsUrl(input);
            }
            return input;
        };
    }]).filter('trsResourceUrl', ['$sce',
    function($sce) {
        return function(input) {
            if (angular.isDefined(input)) {
                input = $sce.trustAsResourceUrl(input);
            }
            return input;
        };
    }
]);
